import { Loader2, Lock } from "lucide-react";
import { useForumAccessQuery } from "../api/forumApi";

/**
 * What a non-member sees instead of the forum.
 *
 * This is presentation, not protection. Every endpoint the pages inside call
 * is behind the `policy.committee` middleware on the server, which re-derives
 * the committee from the offices held today. Someone who types the URL gets
 * empty screens and 403s either way; this just explains why rather than
 * leaving them looking at a broken page.
 */
export default function ForumGate({ children }: { children: React.ReactNode }) {
  const { data, isLoading, isError } = useForumAccessQuery();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-24 text-gray-400">
        <Loader2 className="w-5 h-5 animate-spin" />
      </div>
    );
  }

  if (isError || !data?.allowed) {
    return (
      <div className="max-w-lg mx-auto text-center py-24 px-6">
        <div className="w-14 h-14 rounded-2xl bg-gray-100 flex items-center justify-center mx-auto mb-5">
          <Lock className="w-6 h-6 text-gray-400" />
        </div>
        <h1 className="text-lg font-black text-gray-900 tracking-tight">
          Policy Committee only
        </h1>
        <p className="text-sm text-gray-500 mt-2 leading-relaxed">
          This forum is open to members of the National Policy Committee — those
          currently serving in a national position, and the chapter chairmen who
          sit on it ex officio. Membership follows the office, so it changes when
          the office does.
        </p>
        <p className="text-xs text-gray-400 mt-4">
          If you believe you should be here, the secretariat maintains the
          national positions register.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
